module.exports = __webpack_public_path__ + "img/logo-up-new-11.331d8699.png";